var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('Icon',{attrs:{"type":"empty"}}),_c('p',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.$t('com_table_no_data')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }